document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-card .product-form__radio-label').forEach(function (label) {
    label.addEventListener('click', function () {
      const variantId = label.getAttribute('data-value');
      const productCard = label.closest('.product-card');
  
      if (!productCard) return;
  
      // Remove 'active' class from all labels in the same product card
      const allLabels = productCard.querySelectorAll('.product-form__radio-label');
      allLabels.forEach(function (lbl) {
        lbl.classList.remove('active');
      });
  
      // Add 'active' class to the clicked label
      label.classList.add('active');
  
      // Uncheck all .product-form__radio inputs
      const radioInputs = productCard.querySelectorAll('.product-form__radio');
      radioInputs.forEach(function (input) {
        input.checked = false;
      });
  
      // Check the radio input *next to* the clicked label
      const associatedInput = label.previousElementSibling;
      if (associatedInput && associatedInput.classList.contains('product-form__radio')) {
        associatedInput.checked = true;
      }
  
      // Update hidden input with selected variant ID
      const productForm = productCard.querySelector('.product-form');
      if (!productForm) return;
  
      const idInput = productForm.querySelector('input[name="id"]');
      const addToCartButton = productForm.querySelector('[type="submit"], .add-to-cart');
  
      if (variantId && idInput && addToCartButton) {
        idInput.value = variantId;
        // addToCartButton.click(); // Uncomment if auto-clicking is needed
      }
    });
  });

  const panels = document.querySelectorAll('.mobile-quick-add-to-cart');
  const overlays = document.querySelectorAll('.overlay');
  
  document.querySelectorAll('[data-quick-add-to-cart]').forEach(button => {
    button.addEventListener('click', function () {
      const targetId = this.getAttribute('data-quick-add-to-cart');
      const targetDiv = document.getElementById(targetId);

      // Remove 'active' from all panels and overlays first
      panels.forEach(panel => panel.classList.remove('active'));
      overlays.forEach(overlay => overlay.classList.remove('active'));

      const overlayDiv = targetDiv.nextElementSibling;
      
      // Add 'active' to the selected panel
      if (targetDiv) {
        targetDiv.classList.add('active');
      }
      
      // Add 'active' to the selected overlay
      if (overlayDiv) {
        overlayDiv.classList.add('active');
      }
    });
  });

  // Optional close button inside each panel
  document.querySelectorAll('.quick-cart-close-btn').forEach(button => {
    button.addEventListener('click', function () {
      // Remove 'active' from all panels and overlays first
      panels.forEach(panel => panel.classList.remove('active'));
      overlays.forEach(overlay => overlay.classList.remove('active'));
    });
  });

  // Optional close button inside each panel
  document.querySelectorAll('.overlay').forEach(button => {
    button.addEventListener('click', function () {
      // Remove 'active' from all panels and overlays first
      panels.forEach(panel => panel.classList.remove('active'));
      overlays.forEach(overlay => overlay.classList.remove('active'));
    });
  });

  // For quick add to cart in cart template
  const container = document.querySelector("#your-shopping-cart");

  if (container) {
    container.addEventListener("click", function (e) {
      const target = e.target;

      // Check if the clicked element is the submit button inside a product card
      if (target.matches("product-card .product-form__submit, product-card .product-form__submit *")) {
        e.preventDefault();

        // Find the closest form or wrapper
        const productCard = target.closest("product-card");

        if (productCard) {
          const variantInput = productCard.querySelector('input[name="id"]');

          if (variantInput && variantInput.value) {
            const variantId = variantInput.value;
            // Redirect to add-to-cart URL
            window.location.href = `/cart/add?id=${variantId}&quantity=1`;
          } else {
            console.warn("Variant ID not found");
          }
        }
      }
    });
  }
});
